<style>
  /*  */
</style>
<div class="pdf-page app-cp-12-18-10-12 font-small" id="cp181012">
  <h3 style="display: flex; justify-content: end">
    <b>COMMERCIAL PROPERTY</b>
  </h3>
  <h3 style="display: flex; justify-content: end"><b>CP 12 18 10 12</b></h3>
  <div>
    <h3 class="font-medium" style="text-align: center">
      <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY.</b>
    </h3>
    <br />
    <h3 class="font-large" style="text-align: center">
      <b>LOSS PAYABLE PROVISIONS</b>
    </h3>
    <br />
  </div>
  <div>
    <p class="font-small">
      This endorsement modifies insurance provided under the following:
    </p>
    <div class="pl-16">
      <p class="text-justify">
        BUILDERS' RISK COVERAGE FORM <br />BUILDING AND PERSONAL PROPERTY
        COVERAGE FORM <br />
        CONDOMINIUM ASSOCIATION COVERAGE FORM <br />CONDOMINIUM COMMERCIAL
        UNIT-OWNERS COVERAGE FORM<br />STANDARD PROPERTY POLICY
      </p>
    </div>
    <br />
  </div>
  <h3 class="font-medium" style="text-align: center"><b>SCHEDULE</b></h3>
  <br />
  <table style="border: 1px solid black; border-collapse: collapse; width: 100%;">
    <thead>
      <tr>
        <th style="border: 1px solid #000; padding: 0 8px">Location Number:</th>
        <th style="border: 1px solid #000; padding: 0 8px">Building Number:</th>
        <th style="border: 1px solid #000; padding: 0 8px">
          Applicable Clause<br />
          (Enter C.1., C.2., C.3. or C.4.):
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="padding: 0 8px">
          <p><b>Description Of Property:</b></p>
          <p><b>Loss Payee Name:</b></p>
          <p><b>Loss Payee Address:</b></p>
        </td>
        <td style="padding: 0 8px"></td>
        <td style="padding: 0 8px"></td>
      </tr>
    </tbody>
  </table>
  <table style="border: 1px solid black; border-collapse: collapse; width: 100%;">
    <thead>
      <tr>
        <th style="border: 1px solid #000; padding: 0 8px">Location Number:</th>
        <th style="border: 1px solid #000; padding: 0 8px">Building Number:</th>
        <th style="border: 1px solid #000; padding: 0 8px">
          Applicable Clause<br />
          (Enter C.1., C.2., C.3. or C.4.):
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="padding: 0 8px">
          <p><b>Description Of Property:</b></p>
          <p><b>Loss Payee Name:</b></p>
          <p><b>Loss Payee Address:</b></p>
        </td>
        <td style="padding: 0 8px"></td>
        <td style="padding: 0 8px"></td>
      </tr>
    </tbody>
  </table>
  <table style="border: 1px solid black; border-collapse: collapse; width: 100%;">
    <thead>
      <tr>
        <th style="border: 1px solid #000; padding: 0 8px">Location Number:</th>
        <th style="border: 1px solid #000; padding: 0 8px">Building Number:</th>
        <th style="border: 1px solid #000; padding: 0 8px">
          Applicable Clause<br />
          (Enter C.1., C.2., C.3. or C.4.):
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="padding: 0 8px">
          <p><b>Description Of Property:</b></p>
          <p><b>Loss Payee Name:</b></p>
          <p><b>Loss Payee Address:</b></p>
        </td>
        <td style="padding: 0 8px"></td>
        <td style="padding: 0 8px"></td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td style="border: 1px solid #000; padding: 0 8px" colspan="3">
          Information required to complete this Schedule, if not shown above,
          will be shown in the Declarations.
        </td>
      </tr>
    </tfoot>
  </table>
</div>

<div class="pdf-page app-cp-12-18-10-12 font-small">
  <table
    class="table-column"
    style="width: 100%; margin: 0 auto; border-spacing: 20px 0"
  >
    <thead>
      <tr>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="vertical-align: top">
          <ol style="list-style: none; counter-reset: item">
            <li style="counter-increment: item" class="text-justify">
              <b>A.</b
              ><span class="pl-8"
                >When this endorsement is attached to the Standard Property
                Policy <b>CP 00 99,</b> the term Coverage Part in this
                endorsement is replaced by the term Policy</span
              >
            </li>
            <li style="counter-increment: item" class="text-justify">
              <b>B.</b
              ><span class="pl-8"
                >Nothing in this endorsement increases the applicable Limit of
                Insurance. We will not pay any Loss Payee more than their
                financial interest in the Covered Property, and we will not pay
                more than the applicable Limit of Insurance on the Covered
                Property.</span
              >
            </li>
            <li style="counter-increment: item" class="text-justify">
              <b>C.</b
              ><span class="pl-8"
                >The following is added to the Loss Payment Loss Condition, as
                indicated in the Declarations or in the Schedule:</span
              >
              <div class="pl-16">
                <b>1.</b><span class="pl-8">Loss Payable Clause</span>
                <p class="text-justify pl-8">
                  For Covered Property in which both you and a Loss Payee shown
                  in the Schedule or in the Declarations have an insurable
                  interest, we will:
                </p>
                <div class="pl-8">
                  <p class="text-justify">
                    <b>(a)</b
                    ><span class="pl-8">Adjust losses with you; and </span>
                  </p>
                  <p class="text-justify">
                    <b>(b)</b
                    ><span class="pl-8"
                      >Pay any claim for loss or damage jointly to you and the
                      Loss Payee, as interests may appear</span
                    >
                  </p>
                </div>
              </div>
              <div class="pl-16">
                <b>2.</b><span class="pl-8">Lender's Loss Payable Clause</span>
                <div class="pl-8">
                  <p class="text-justify">
                    <b>(a)</b
                    ><span class="pl-8"
                      >The Loss Payee shown in the Schedule or in the
                      Declarations is a creditor, including a mortgageholder or
                      trustee, whose interest in Covered Property is established
                      by such written instruments as:</span
                    >
                  </p>
                </div>
                <div class="pl-16">
                  <p class="text-justify">
                    <b>(1)</b><span class="pl-8"></span>Warehouse receipts;
                  </p>
                  <p class="text-justify">
                    <b>(2)</b><span class="pl-8"></span>A contract for deed;
                  </p>
                  <p class="text-justify">
                    <b>(3)</b><span class="pl-8"></span>Bills of lading;
                  </p>
                  <p class="text-justify">
                    <b>(4)</b><span class="pl-8"></span>Financing statements; or
                  </p>
                  <p class="text-justify">
                    <b>(5)</b><span class="pl-8"></span>Mortgages, deeds of
                    trust, or security agreements
                  </p>
                </div>
                <div class="pl-8">
                  <p class="text-justify">
                    <b>(b)</b
                    ><span class="pl-8"
                      >For Covered Property in which both you and a Loss Payee
                      have an insurable interest:</span
                    >
                  </p>
                </div>
                <div class="pl-16">
                  <p class="text-justify">
                    <b>(1)</b><span class="pl-8"></span>We will pay for covered
                    loss or damage to each Loss Payee in their order of
                    precedence, as interests may appear.
                  </p>
                  <p class="text-justify">
                    <b>(2)</b><span class="pl-8"></span>The Loss Payee has the
                    right to receive loss payment even if the Loss Payee has
                    started foreclosure or similar action on the Covered
                    Property.
                  </p>
                </div>
              </div>
            </li>
          </ol>
        </td>
        <td style="vertical-align: top">
          <ol style="list-style: none; counter-reset: item">
            <li style="counter-increment: item" class="text-justify">
              <b>(3)</b
              ><span class="pl-8"
                >If we deny your claim because of your acts or because you have
                failed to comply with the terms of the Coverage Part, the Loss
                Payee will still have the right to receive loss payment if the
                Loss Payee:</span
              >
              <div class="pl-16">
                <p class="text-justify">
                  <b>(a)</b
                  ><span class="pl-8"
                    >Pays any premium due under this Coverage Part at our
                    request if you have failed to do so;</span
                  >
                </p>
                <p class="text-justify">
                  <b>(b)</b
                  ><span class="pl-8"
                    >Submits a signed, sworn proof of loss within 60 days after
                    receiving notice from us of your failure to do so; and
                  </span>
                </p>
                <p class="text-justify">
                  <b>(c)</b
                  ><span class="pl-8"
                    >Has notified us of any change in ownership, occupancy or
                    substantial change in risk known to the Loss Payee</span
                  >
                </p>
                <p class="text-justify">
                  All of the terms of this Coverage Part will then apply
                  directly to the Loss Payee.
                </p>
              </div>
            </li>
            <li style="counter-increment: item" class="text-justify">
              <b>(4)</b
              ><span class="pl-8"
                >If we pay the Loss Payee for any loss or damage and deny
                payment to you because of your acts or because you have failed
                to comply with the terms of this Coverage Part:
              </span>
              <div class="pl-16">
                <p class="text-justify">
                  <b>(a)</b
                  ><span class="pl-8"
                    >The Loss Payee's rights will be transferred to us to the
                    extent of the amount we pay; and</span
                  >
                </p>
                <p class="text-justify">
                  <b>(b)</b
                  ><span class="pl-8"
                    >The Loss Payee's rights to recover the full amount of the
                    Loss Payee's claim will not be impaired</span
                  >
                </p>
                <p class="text-justify">
                  At our option, we may pay to the Loss Payee the whole
                  principal on the debt plus any accrued interest. In this
                  event, you will pay your remaining debt to us
                </p>
              </div>
            </li>
            <li style="counter-increment: item" class="text-justify">
              <b>c.</b
              ><span class="pl-8"
                >If we cancel this policy, we will give written notice to the
                Loss Payee at least:</span
              >
              <div class="pl-16">
                <p class="text-justify">
                  <b>(1)</b
                  ><span class="pl-8"
                    >10 days before the effective date of cancellation if we
                    cancel for your nonpayment of premium; or</span
                  >
                </p>
                <p class="text-justify">
                  <b>(2)</b
                  ><span class="pl-8"
                    >30 days before the effective date of cancellation if we
                    cancel for any other reason.</span
                  >
                </p>
              </div>
            </li>
            <li style="counter-increment: item" class="text-justify">
              <b>d.</b
              ><span class="pl-8"
                >If we elect not to renew this policy, we will give written
                notice to the Loss Payee at least 10 days before the expiration
                date of this policy.</span
              >
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="pdf-page app-cp-12-18-10-12 font-small">
  <div>
    <table>
      <tbody>
        <tr>
          <td style="vertical-align: top">
            <ol style="list-style: none; counter-reset: item">
              <li style="counter-increment: item" class="text-justify">
                <div class="pl-16">
                  <b>3.</b><span class="pl-8">Contract Of Sale Clause</span>
                  <div class="pl-8">
                    <p class="text-justify">
                      <b>a.</b
                      ><span class="pl-8"
                        >The Loss Payee shown in the Schedule or in the
                        Declarations is a person or organization you have
                        entered into a contract with for the sale of Covered
                        Property</span
                      >
                    </p>
                    <p class="text-justify">
                      <b>b.</b
                      ><span class="pl-8"
                        >For Covered Property in which both you and the Loss
                        Payee have an insurable interest, we will:</span
                      >
                    </p>
                  </div>
                  <div class="pl-16">
                    <p class="text-justify">
                      <b>(1.)</b
                      ><span class="pl-8">Adjust losses with you; and </span>
                    </p>
                    <p class="text-justify">
                      <b>(2.)</b
                      ><span class="pl-8"
                        >Pay any claim for loss or damage jointly to you and the
                        Loss Payee, as interests may appear.</span
                      >
                    </p>
                  </div>
                  <div class="pl-8">
                    <p class="text-justify">
                      <b>c.</b
                      ><span class="pl-8"
                        >The following is added to the
                        <b>Other Insurance</b> Condition:
                      </span>
                    </p>
                    <p class="text-justify pl-8">
                      For Covered Property that is the subject of a contract of
                      sale, the word "you" includes the Loss Payee.
                    </p>
                  </div>
                </div>
              </li>
            </ol>
          </td>
          <td style="vertical-align: top">
            <ol style="list-style: none; counter-reset: item">
              <li style="counter-increment: item" class="text-justify">
                <div class="pl-16">
                  <b>4.</b
                  ><span class="pl-8">Building Owner Loss Payable Clause</span>
                  <div class="pl-8">
                    <p class="text-justify">
                      <b>a.</b
                      ><span class="pl-8"
                        >The Loss Payee shown in the Schedule or in the
                        Declarations is the owner of the described building in
                        which you are a tenant.
                      </span>
                    </p>
                    <p class="text-justify">
                      <b>b.</b
                      ><span class="pl-8"
                        >We will adjust losses to the described building with
                        the Loss Payee. Any loss payment made to the Loss Payee
                        will satisfy your claims against us for the owner's
                        property.</span
                      >
                    </p>
                    <p class="text-justify">
                      <b>c.</b
                      ><span class="pl-8"
                        >We will adjust losses to tenant's improvements and
                        betterments with you, unless the lease provides
                        otherwise.</span
                      >
                    </p>
                  </div>
                </div>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
